import { TriageType } from '~/services/api/enums';

const triageTypeOptions = [
  {
    value: TriageType.WaitingReply,
    label: 'Await Reply',
  },
  {
    value: TriageType.Completed,
    label: 'Completed',
  },
];

export default triageTypeOptions;
